var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6666L11.6666 8.99996V11.6666H4.99996V4.99996H11.6666V7.66663L15 4.99996V11.6666ZM16.6666 1.66663H3.33329C2.89127 1.66663 2.46734 1.84222 2.15478 2.15478C1.84222 2.46734 1.66663 2.89127 1.66663 3.33329V18.3333L4.99996 15H16.6666C17.1087 15 17.5326 14.8244 17.8451 14.5118C18.1577 14.1992 18.3333 13.7753 18.3333 13.3333V3.33329C18.3333 2.40829 17.5833 1.66663 16.6666 1.66663Z",
    fill: "url(#paint0_linear_676_498)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_498",
    x1: 5.23057,
    y1: -12.645,
    x2: 31.5261,
    y2: 5.61303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536953,
    stopColor: "#FF695C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF475E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video.b20eefc32f7571fed73f533ebe23ba81.svg";